import { Injectable } from '@angular/core';
@Injectable({ providedIn: 'root' })
export class ClipboardService {
  async write(value: string): Promise<void> {
    if (navigator.clipboard?.writeText) { await navigator.clipboard.writeText(value); return; }
    const textarea = document.createElement('textarea'); textarea.value = value; textarea.style.position = 'fixed'; textarea.style.opacity = '0'; document.body.appendChild(textarea); textarea.select(); document.execCommand('copy'); textarea.remove();
  }
}
